import React from 'react';
import { Box, Flex, Text } from '@mafc/trolly';

import PageMaxWidth from 'common/PageLayout/PageMaxWidth';

const STYLE_PROPS = {
  flexDirection: ['column', 'column', 'column', 'row'],
  pb: [3, 4],
  pt: [2],
  // For ShareCart positioning}
  sx: {
    position: ['relative', null, null, 'static'],
  },
};

interface CustomFC extends React.FC {
  Flex: React.FC<{ children: React.ReactNode }>;
  LeftBox: React.FC<{ children: React.ReactNode }>;
  RightBox: React.FC<{ children: React.ReactNode }>;
  Title: React.FC<{ children: React.ReactNode }>;
  children: React.ReactNode;
}
// @ts-ignore
const CartCheckoutContainer: CustomFC = props => <PageMaxWidth {...props} />;
export default CartCheckoutContainer;

CartCheckoutContainer.Flex = props => <Flex {...STYLE_PROPS} {...props} />;
CartCheckoutContainer.LeftBox = props => (
  <Box width={[1, 1, 1, 8 / 12]} mr={[0, 0, 4]} {...props} />
);
CartCheckoutContainer.RightBox = props => (
  <Box width={[1, 1, 1, 8 / 12]} mr={[0, 0, 4]} {...props} />
);

CartCheckoutContainer.Title = props => (
  <Text.H3
    color="transparent"
    display={['none', null, null, 'block']}
    fontSize={3}
    fontWeight={4}
    mb={3}
    {...props}
  />
);
